import blancoEsmerilado from "../assets/new-products-images/blanco-esmerilado.jpg";
import negroMate from "../assets/new-products-images/negro-mate.jpg";
import metalico from "../assets/new-products-images/metalico.jpg";

const newProducts = [
  {
    id: 1,
    name: "Vela en bote (blanco esmerilado)",
    dimensions: "180gr",
    price: "7,5€",
    image: blancoEsmerilado,
  },
  {
    id: 2,
    name: "Vela en bote (negro mate)",
    dimensions: "150gr",
    price: "6,5€",
    image: negroMate,
  },
  {
    id: 3,
    name: "Vela en bote (metálico)",
    dimensions: "100gr",
    price: "4€",
    image: metalico,
  },
];

export default newProducts;
